import type {JSX} from 'react'

import {Tooltip as ReactTooltip} from 'react-tooltip'
import {v4 as uuidv4} from 'uuid'

interface TooltipProps {
  title: string
}

export default function Tooltip(props: Readonly<TooltipProps>): JSX.Element {
  const id: string = uuidv4()
  return (
    <div className='d-inline-block'>
      <i className='text-primary ms-2 fas fa-question-circle' data-tooltip-content={null} data-tooltip-id={id}/>
      <ReactTooltip id={id} variant='dark'>
        {props.title}
      </ReactTooltip>
    </div>
  )
}
